module.exports = __webpack_public_path__ + "static/media/chrome-desktop-step-2.da6869dd.png";